// src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tailwind.css";
import "./styles/customize-progress-bar.css";
import App from "./App";
import "animate.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
